export default __webpack_public_path__ + "static/network-4-8e0cf83bff9f8696b0ca50c5a69bd922.png";